<template>
  <div>
    <PageTitle title="Meus Parceiros" />

    <div class="d-flex justify-content-end mr-5 mb-5">
      <b-button
        variant="primary"
        @click="$refs.allProductSyncPartherModal.toggleOpen({idShopkeeper: dadosUsuario.id})"
      >
        <i class="fas fa-user mr-2"></i> 
        Produtos Vinculados
      </b-button>

      <b-button variant="success" @click="openModal()" class="ml-4">
        <i class="fas fa-plus"></i>
        Adicionar Parceiro
      </b-button>
    </div>

    <div cols="12" class="mt-3 d-flex justify-content-around">
      <b-form-input
        v-model="partnerName"
        type="text"
        style="max-width: 80%;"
        placeholder="Digite o nome do parceiro"
        @change="getPartners()"
      ></b-form-input>
      <b-button
        class="ml-2"
        style="min-width: 15%;"
        variant="success"
        @click="getPartners()"
      >Pesquisar</b-button>
      
      <b-button
        class="ml-2"
        style="min-width: 15%;"
        variant="warning"
        @click="clearFields()"
      >Limpar Pesquisa</b-button>
  </div>

    <b-table
      striped
      responsive
      hover
      :fields="table.headers"
      :items="table.records"
      :busy="loading"
      class="mt-5"
    >
      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle mr-2"></b-spinner>
          <strong>Carregando...</strong>
        </div>
      </template>

      <template #cell(cnpj)="data">
        {{ data.item.cnpj }}
      </template>

      <template #cell(nome_fantasia)="data">
        {{ data.item.nome_fantasia }}
      </template>

      <template #cell(nome)="data">
        {{ data.item.nome }}
      </template>

      <template #cell(email)="data">
        {{ data.item.email }}
      </template>

      <template #cell(actions)="data">
        <b-button
          variant="success"
          @click="modalSyncProduct(
            data.item.partner_id,
            data.item.nome
          )"
          title="Vincular produto ao parceiro"
        >
          <i class="fas fa-plus"></i> 
        </b-button>
      
        <b-button
        class="mx-2"
          variant="warning"
          title="Mostrar Produtos dos parceiro"
          @click="$refs.allProductPartherModal.toggleOpen({
            idPartner:data.item.partner_id,
            idShopkeeper: dadosUsuario.id,
            name: data.item.nome
          })"
        >
          <i class="fas fa-eye"></i> 
        </b-button>

        <b-button
        class="mx-2"
          variant="danger"
          title="Deletar parceiro(?)"
          @click="$refs.deletePartnerModal.toggleOpen({partnerId: data.item.partner_id})"
        >
          <i class="fas fa-trash"></i> 
        </b-button>
      </template>
    </b-table>
    
    <NewPartnerRegister
      ref="newPartnerRegister"
      @updateTable="getPartners()"
    />

    <DeletePartnerModal
      ref="deletePartnerModal"
      @deletePartner="deletePartner($event.partnerId)"
    />

    <ProductPartnerModal 
      ref="productPartherModal"
      @closeProductPartnerModal="getPartnersProducts()"
    />

    <AllProductPartnerModal 
      ref="allProductPartherModal"
    />

    <AllProductSyncPartnerModal 
      ref="allProductSyncPartherModal"
    />
  </div>
</template>

<script>
import PageTitle from 'Components/PageTitle.vue';
import { mapState, mapActions } from 'vuex';
import NewPartnerRegister from './NewPartnerRegister.vue';
import ProductPartnerModal from 'Components/partner/ProductPartnerModal.vue';
import AllProductPartnerModal from 'Components/partner/AllProductPartnerModal.vue';
import AllProductSyncPartnerModal from 'Components/partner/AllProductSyncPartnerModal.vue';
import DeletePartnerModal from '@/views/lojista/DeletePartnerModal.vue';
import shopkeeperAppApi from '@/api/shopkeeperAppApi';

export default {
  components: {
    PageTitle,
    NewPartnerRegister,
    ProductPartnerModal,
    AllProductPartnerModal,
    AllProductSyncPartnerModal,
    DeletePartnerModal
  },
  data() {
    return {
      partnerName: '',
      partnerIdDelete: "",
      table: {
        headers: [
          {
            key: 'nome_fantasia',
            label: 'Parceiro',
            sortable: false,
          },
          {
            key: 'nome',
            label: 'Nome',
            sortable: false,
          },
          {
            key: 'cnpj',
            label: 'CNPJ',
            sortable: false,
          },
          {
            key: 'email',
            label: 'E-mail',
            sortable: false,
          },
          {
            key: 'actions',
            label: 'Ações',
            sortable: false,
          },
        ],
        records: [],
      },
    }
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState({
      dadosUsuario: (state) => state.dadosUsuario,
    }),
  },

  mounted() {
    this.getPartners();
  },

  methods: {
    ...mapActions('shopkeeper', ['getAllPartners', 'softDeletePartner']),

    getPartners() {
      this.table.records = [];

      this.$store.dispatch('startLoader');
      this.loading = true;

      const data = {
        search: this.partnerName,
        idShopkeeper: this.dadosUsuario.id,
      };
      
      this.getAllPartners(data)
        .then((response) => {
          this.table.records = response.data;
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },

    deletePartner(partnerId) {
      this.$store.dispatch('startLoader');
      this.loading = true;

      this.softDeletePartner({
        partnerId: partnerId,
        shopkeeperId: this.dadosUsuario.id
      }).then(() => {
        this.deleteProductPartner(partnerId);
        this.$store.dispatch('endLoader');
      })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.getPartners();
          this.loading = false;
        });
    },
    
    async deleteProductPartner(partnerId) {
      const item = {
        "partner_user_id": partnerId,
        "construp_user_id": this.dadosUsuario.id
      }

      try {
        this.$store.dispatch('startLoader');
        const { data } = await shopkeeperAppApi.post(
          '/products/partners/delete-product-partner', item );
        
        if(data.data){
          this.makeToast('sucesso', 'Parceiro deletado com sucesso', 'success');
        };
        
        this.$store.dispatch('endLoader');
      } catch (error) {
        this.$store.dispatch('endLoader');
        this.makeToast('error', 'Erro ao deletar o parceiro', 'danger');
      }
    },
    
    clearFields() {
      this.partnerName = '';
      this.getPartners();
    },
    openModal() {
      this.$refs.newPartnerRegister.toggleOpen();
    },

    modalSyncProduct(idPartner, name){
      this.$refs.productPartherModal.toggleOpen({
        idPartner,
        idShopkeeper: this.dadosUsuario.id,
        name
      });
    },
  }
}
</script>